import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ThemeCustomTokens {
  colorPrimary: string;
  sidebarBg: string;
  sidebarActiveBg: string;
  sidebarText: string;
}

export const DEFAULT_THEME_TOKENS: ThemeCustomTokens = {
  colorPrimary: '#a4193d',
  sidebarBg: '#1a1a2e',
  sidebarActiveBg: '#a4193d',
  sidebarText: '#ffffff',
};

interface ThemeState {
  customTokens: ThemeCustomTokens;
}

const initialState: ThemeState = {
  customTokens: DEFAULT_THEME_TOKENS,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeTokens: (state, action: PayloadAction<Partial<ThemeCustomTokens>>) => {
      Object.assign(state.customTokens, action.payload);
    },
    resetTheme: () => initialState,
  },
});

export const { setThemeTokens, resetTheme } = themeSlice.actions;
export default themeSlice.reducer;
